import React from 'react';
import type { Storyline } from '@akem/shared';

type StorylineChatContextValue = {
  activeStoryline: Storyline | null;
  setActiveStoryline: (storyline: Storyline | null) => void;
};

const StorylineChatContext = React.createContext<StorylineChatContextValue | undefined>(
  undefined
);

export const StorylineChatProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [activeStoryline, setActiveStoryline] = React.useState<Storyline | null>(null);

  const value = React.useMemo(
    () => ({ activeStoryline, setActiveStoryline }),
    [activeStoryline]
  );

  return (
    <StorylineChatContext.Provider value={value}>
      {children}
    </StorylineChatContext.Provider>
  );
};

export function useStorylineChatContext(): StorylineChatContextValue {
  const ctx = React.useContext(StorylineChatContext);
  if (!ctx) {
    throw new Error('useStorylineChatContext must be used within a StorylineChatProvider');
  }
  return ctx;
}

